import { UFOExperience, ExperienceTypes, ExperiencePerformanceTypes } from '@atlassian/ufo';
import { createJpdExperience } from '../../utils/experience/main.tsx';
import type { JPDExperience } from '../../utils/experience/types.tsx';

export const pageSegmentLoad: JPDExperience = createJpdExperience(
	new UFOExperience('jpd.list-view', {
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	}),
);

export const createIdeaInline = createJpdExperience(
	new UFOExperience('jpd.list-view.create-idea-inline', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

export const createIdeaInlineBulk = createJpdExperience(
	new UFOExperience('jpd.list-view.create-idea-inline-bulk', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

// this metric is meant to measure the time between clicking to add an idea inline and the input row appearing
export const createIdeaInlineClickResponse = createJpdExperience(
	new UFOExperience('jpd.list-view.create-idea-inline-button-click', {
		type: ExperienceTypes.Operation,
		performanceType: ExperiencePerformanceTypes.Custom,
	}),
);

export const changeViewName = createJpdExperience(
	new UFOExperience('jpd.list-view.change-view-name', {
		type: ExperienceTypes.Experience,
		performanceType: ExperiencePerformanceTypes.InlineResult,
	}),
);

// measure list scroll performance
export const listScrollPerformance = createJpdExperience(
	new UFOExperience('jpd.list-view.scroll-performance', {
		type: ExperienceTypes.Operation,
		performanceType: ExperiencePerformanceTypes.Custom,
	}),
);

/**
 * Since field updates can be frequent, makeFieldUpdate is a factory
 * to avoid conccurency problems as JPDExperience objects are singletons.
 */
export const makeFieldUpdate = () =>
	createJpdExperience(
		new UFOExperience('jpd.list-view.field-update', {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
			timings: [
				{ key: 'internal_state', endMark: 'backend_request_start' },
				{ key: 'backend_request', startMark: 'backend_request_start' },
			],
		}),
	);
